import {BASE_API} from '../../utils/constantes'
import { getToken } from '../Common/token'
import { STORAGE_KEYS } from '../../utils/constantes';

export async function checkReport(request_get){
    try {
        
        const url =  `${BASE_API}/api/check-report/?hash=${request_get}`
            
        const params = {
            headers:{
                Authorization:`Bearer ${getToken()}`
            }
        }
        const response = await fetch(url,params)
       
        if(response.status === 200){
           
            const result= await response
          
            return result
            
        }
        return response
        
    } catch (error) {
        return false
    }
}




export function removeNotification(){
    localStorage.removeItem(STORAGE_KEYS.HASH)
    localStorage.removeItem(STORAGE_KEYS.INTERVAL_ID)
    localStorage.removeItem(STORAGE_KEYS.NOTIFICATION_DATA)
}

export function addHash(hash){
    let hashes_current = localStorage.getItem(STORAGE_KEYS.HASH) === null ? [] : JSON.parse(localStorage.getItem(STORAGE_KEYS.HASH)); 
  
    hashes_current.push(hash)

    
    localStorage.setItem(STORAGE_KEYS.HASH, JSON.stringify(hashes_current));
    return true;
}

export function removeHash(hash){
    // Crear un nuevo array sin el valor a remover
    let newArray = JSON.parse(localStorage.getItem(STORAGE_KEYS.HASH)).filter(valor => valor !== hash);
   
    if (newArray.length === 0 )
        localStorage.removeItem(STORAGE_KEYS.HASH)
    else
        localStorage.setItem(STORAGE_KEYS.HASH, JSON.stringify(newArray))

    return true;
}

